import { IOptionsModel, WithId } from 'models/shared.models'
import SydTabChip from '../SydTabChip/SydTabChip'
import './styles.scss'

export interface ISydTabChipsProps<TTabChip> {
  options: Readonly<WithId<IOptionsModel<TTabChip>>[]>
  selectedValue: TTabChip
  handleSelectValue: (value: TTabChip) => void
}

const SydTabChips = <TTabChip,>({
  options,
  selectedValue,
  handleSelectValue,
}: ISydTabChipsProps<TTabChip>) => {
  return (
    <div className="syd-tab-chips-component">
      {options.map(({ id, label, value }) => {
        return (
          <SydTabChip<TTabChip>
            key={`syd-tab-chips-${id}`}
            label={label}
            value={value}
            selectedValue={selectedValue}
            handleSelectValue={handleSelectValue}
          />
        )
      })}
    </div>
  )
}

export default SydTabChips
